<template>
    <v-container fluid>
        <v-card>
            <v-card-title class="pb-2 pt-2">
                <v-icon left color="primary">mdi-rv-truck</v-icon>
                Fuhrpark
            </v-card-title>
            <v-divider/>
            <v-card-text>
                {{ filter }}
                <v-row>
                    <v-col>
                        <v-select label="Unit / Abteilung" multiple clearable dense outlined prepend-inner-icon="mdi-office-building-marker-outline" v-model="filter.unit" :items="availableUnits"></v-select>
                    </v-col>
                    <v-col>
                        <v-select label="Hersteller" multiple clearable dense outlined prepend-inner-icon="mdi-rv-truck" v-model="filter.manufacturer" :items="availableManufacturer"></v-select>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider/>
            <v-data-table locale="de-DE" :items="vehicles" :headers="tableHeaders">

            </v-data-table>
        </v-card>
    </v-container>
</template>

<script>
export default {
    computed: {
        availableManufacturer() {
            let options = new Set();
            this.vehicles.forEach(vehicle => {
                options.add(vehicle.manufacturer || 'Unbekannter Hersteller');
            })
            return [...options];
        },
        availableUnits() {
            let options = new Set();
            this.vehicles.forEach(vehicle => {
                options.add(vehicle.unit || 'Unbekannte Einheit');
            })
            return [...options];
        }
    },
    data: () => ({
        filter: {
            unit: [],
            manufacturer: [],
        },
        tableHeaders: [
            {text: 'Hersteller', value: 'manufacturer'},
            {text: 'Modell', value: 'model'},
            {text: 'Kennzeichen', value: 'plate'},
            {text: 'Unit / Abteilung', value: 'unit'},
            {text: 'Rank', value: 'requiredRank'},
            {text: 'Zugewiesener Beamter', value: 'assignedOfficer.displayName'}
        ],
        vehicles: [
            {
                id: 1,
                manufacturer: 'Benefactor',
                model: 'Kanzler',
                plate: 'SZ ND 93',
                requiredRank: 'Direktor (PD)',
                assignedOfficer: {
                    displayName: '(P-01) Lena Machslochov',
                },
                unit: 'Leitung der Bundespolizei',
            },
            {
                id: 2,
                manufacturer: 'Obey',
                model: 'Avant 6',
                plate: 'BD10 394',
                requiredRank: '-',
                assignedOfficer: {
                    displayName: '(P-01) Lena Machslochov',
                },
                unit: 'Bundesamt für Justiz (BfJ)',
            },
            {
                id: 3,
                manufacturer: 'Obey',
                model: 'Avant 4',
                plate: 'BP28 432',
                requiredRank: '-',
                assignedOfficer: null,
                unit: 'Schutzpolizei',
            }
        ]
    })

};
</script>